// src/hooks/useThemeMode.js
import { useRecoilState } from "recoil";
import themeAtom from "../store/themeAtom";

function useThemeMode() {
  const [theme, setTheme] = useRecoilState(themeAtom);

  return {
    theme,
    setTheme,
    isDark: theme === "dark",
    isLight: theme === "light",
  };
}

export default useThemeMode;
